import { Record } from "immutable";

import CheckboxStates from "../../../../constants/checkboxStates";
import createFromJS from "../../../createFromJS";

export const PopoverMenuItemRecord = Record({
  id: "",
  label: "",
  icon: "",
  color: "",
  disabled: false,
  shortcut: "",
  state: CheckboxStates.UNCHECKED,
  description: ""
});

createFromJS.registerCallback("PopoverMenuItemRecord", createFromJS.createPrimitiveCallback(PopoverMenuItemRecord));
